module.exports = require('./helpers/bundle-url').getBundleURL('9vyx9') + "logo-dark.eefe0b7f.svg";